export class ControllerRelationshipView {
  constructor(private name: string, private returnFieldValues: boolean, private returnAvailableValues: boolean, displayFields: any, displayRelationships: any ) {}
}
